"use client";

import {
  Type,
  Heading1,
  Heading2,
  Heading3,
  List,
  ListOrdered,
  CheckSquare,
  Quote,
  Code,
  Minus,
  ImageIcon,
  Video,
  Music,
  Table2,
  Database,
  FileText,
} from "lucide-react";
import { ComponentType, SVGProps } from "react";

type BlockType =
  | "paragraph"
  | "heading1"
  | "heading2"
  | "heading3"
  | "bulletList"
  | "numberedList"
  | "todoList"
  | "quote"
  | "code"
  | "divider"
  | "image"
  | "video"
  | "audio"
  | "table"
  | "database"
  | "page";

interface BlockTypeIconProps {
  type: BlockType;
  size?: number;
  className?: string;
}

const iconMap: Record<BlockType, ComponentType<SVGProps<SVGSVGElement>>> = {
  paragraph: Type,
  heading1: Heading1,
  heading2: Heading2,
  heading3: Heading3,
  bulletList: List,
  numberedList: ListOrdered,
  todoList: CheckSquare,
  quote: Quote,
  code: Code,
  divider: Minus,
  image: ImageIcon,
  video: Video,
  audio: Music,
  table: Table2,
  database: Database,
  page: FileText,
};

export function BlockTypeIcon({ type, size = 16, className = "" }: BlockTypeIconProps) {
  const Icon = iconMap[type] || Type;

  return (
    <Icon
      width={size}
      height={size}
      className={`flex-shrink-0 ${className}`}
    />
  );
}

export { type BlockTypeIconProps, type BlockType };
